<div class="col-12">
  <div class="col-12">
    <!-- メモボタン -->
    <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="parentOpenMemoModal">
      {{ $t('message.button_vehicle_dtc_note_modal') }}
    </b-button>
    <b-button v-if="testModeVisible" class="ml-2 mt-2" variant="primary" size="sm" @click="debugExport">
      Export Permanent Data
    </b-button>
    <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="csvExport">
      {{ $t('message.file_export') }}
    </b-button>
  </div>
  <div class="col-12">
    <custom-table class="mt-2 ml-2" type="simple" useSort useStripeStyle rowSelect hasTabs currentSortkey="status"
      initSortDir="asc" :items="measuredDataItems" :columns="measuredDataColumns">
    </custom-table>
  </div>
  <processing-view :processing="processing"></processing-view>
</div>